import { computed } from 'vue';
import i18n, { ZH, ZH_HK, EN } from '@/locales';
const useCurrentReactive = () => {
    const content = computed(() => {
        const localeText = {
            [ZH]: `映恩生物始终将企业管治视为公司可持续发展的核心基石。我们致力于构建透明、高效、合规的治理体系，确保公司运营的稳健性和长期价值创造。通过建立健全的董事会结构、明确的权责划分以及严格的内部控制机制，我们为股东、员工、合作伙伴及社会各界的利益相关方提供坚实的保障。映恩生物秉持诚信经营、责任担当的理念，持续优化管治实践，以最高标准履行企业社会责任，推动生物医药行业的创新与发展，为投资者创造可持续的回报。`,
            [ZH_HK]: `映恩生物始終將企業管治視爲公司可持續髮展的核心基石。我們緻力於構建透明、高效、合規的治理體繫，確保公司運營的穩健性和長期價值創造。通過建立健全的董事會結構、明確的權責劃分以及嚴格的內部控製機製，我們爲股東、員工、合作夥伴及社會各界的利益相關方提供堅實的保障。映恩生物秉持誠信經營、責任擔當的理唸，持續優化管治實踐，以最高標準履行企業社會責任，推動生物醫藥行業的創新與髮展，爲投資者創造可持續的回報。`,
            [EN]: `DualityBio consistently regards corporate governance as the cornerstone of the company's sustainable development. We are committed to building a transparent, efficient, and compliant governance system to ensure the robustness of our operations and the creation of long-term value. By establishing a sound board structure, clear division of responsibilities, and rigorous internal control mechanisms, we provide solid safeguards for shareholders, employees, partners, and stakeholders from all sectors of society. Guided by the principles of integrity and accountability, DualityBio continuously optimizes governance practices, fulfills corporate social responsibilities to the highest standards, and drives innovation and development in the biopharmaceutical industry, thereby delivering sustainable returns to investors.`
        };
        return localeText[i18n.locale];
    });
    
    const btnTextDirectors = computed(() => {
        const localeText = {
            [ZH]: `董事会`,
            [ZH_HK]: `董事會`,
            [EN]: `Board of Directors`
        };
        return localeText[i18n.locale];
    });
    const btnTextCommittee = computed(() => {
        const localeText = {
            [ZH]: `管理委员会`,
            [ZH_HK]: `管理委員會`,
            [EN]: `Management Committee`
        };
        return localeText[i18n.locale];
    });

    const directorsUrl = computed(() => {
        return i18n.locale === ZH
            ? 'https://www.dualitybiologics.com/about/newpath17336633795104/index.html'
            : 'https://en.dualitybiologics.com/17335557462712/newpath17335561378173/index.html';
    });
    const committeeUrl = computed(() => {
        return i18n.locale === ZH
            ? 'https://www.dualitybiologics.com/17335557462712/newpath17335561684246/index.html'
            : 'https://en.dualitybiologics.com/17335557462712/newpath17335561378173/index.html';
    });
    return {
        content,
        btnTextDirectors,
        btnTextCommittee,
        directorsUrl,
        committeeUrl
    };
}

export { useCurrentReactive };